import * as ACTIONS from "../actions";

import Api from "../../services";

import cm from "./CommonFunction";

const CommodityModule = {
  state: {
    loading: false,
    errorMessage: null,
    COMMODITIES: [],
    totalPages: 1,
    saveLoading: false,
    saveError: null,
  },

  getters: {
    commodityLoading: (state) => state.loading,
    CommodityErrorMessage: (state) => state.errorMessage,
    commodityTotalPage: (state) => state.totalPages,
    commodities: (state) => state.COMMODITIES,
    CommoditysaveLoading: (state) => state.saveLoading,
    commoditysaveError: (state) => state.saveError,
  },

  actions: {
    [ACTIONS.COMMODITY_GETALL]: (context, query) => {
      var { commit, state } = context;

      commit(ACTIONS.COMMODITY_GETALL_PENDING);
      return new Promise((resolve, reject) => {
        var url = "commodities/getAll" + query;
        Api.get(url, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.COMMODITY_GETALL_SUCCESS, data.ResponseData);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.COMMODITY_GETALL_ERROR, data.StatusMessage);
            } else {
              commit(ACTIONS.COMMODITY_GETALL_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              commit(ACTIONS.COMMODITY_GETALL_ERROR, "Error " + err.status);
            }
            if (err.request) {
              commit(ACTIONS.COMMODITY_GETALL_ERROR, err.message);
            } else {
              // Something happened in setting up the request that triggered an Error

              commit(ACTIONS.COMMODITY_GETALL_ERROR, "Error " + err.message);
            }

            return reject(err);
          });
      });
    },
    [ACTIONS.VENDOR_COMMODITY_SAVE]: (context, data) => {
      var { commit, state } = context;
      var params = new URLSearchParams();
      params.append("ParentId", data.ParentId);
      for (var i = 0; i < data.Commodities.length; i++) {
        params.append("Commodities[" + i + "].Id", data.Commodities[i].Id);
      }
      commit(ACTIONS.VENDOR_COMMODITY_SAVE_PENDING);
      return new Promise((resolve, reject) => {
        Api.post("vendors/SaveVendorCommodities", params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.VENDOR_COMMODITY_SAVE_SUCCESS);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.VENDOR_COMMODITY_SAVE_ERROR, data.StatusMessage);
            } else if (data && data.StatusCode == 450) {
              commit(
                ACTIONS.VENDOR_COMMODITY_SAVE_ERROR,
                "Data is not valid format.",
              );
              return resolve(res);
            } else {
              commit(ACTIONS.VENDOR_COMMODITY_SAVE_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              //var { data } = err.response;
              if (err.response.status == 500) {
                context.commit(
                  ACTIONS.VENDOR_COMMODITY_SAVE_ERROR,
                  "Internal server error",
                );
              } else {
                context.commit(
                  ACTIONS.VENDOR_COMMODITY_SAVE_ERROR,
                  "Error " + err.status,
                );
              }
            } else if (err.request) {
              context.commit(
                ACTIONS.VENDOR_COMMODITY_SAVE_ERROR,
                "Error " + err.request,
              );
            } else {
              // Something happened in setting up the request that triggered an Error

              context.commit(
                ACTIONS.VENDOR_COMMODITY_SAVE_ERROR,
                "Error " + err.message,
              );
            }
            return reject(err);
          });
      });
    },
    [ACTIONS.COMMODITY_CHECK_DUPLICATE]: (context, data) => {
      return new Promise((resolve, reject) => {
        var params = new URLSearchParams();
        params.append("value", data.value);
        params.append("otherData[0].key", "id");
        params.append("otherData[0].value", data.id == null ? 0 : data.id);
        Api.post(data.Url, params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (res.status == 200) {
              return resolve({
                data: data.isValid,
              });
            } else {
              return resolve({
                data: true,
              });
            }
          })
          .catch((err) => {
            return reject({
              data: true,
            });
          });
      });
    },
    [ACTIONS.COMMODITY_SAVE]: (context, data) => {
      return new Promise((resolve, reject) => {
        var { commit } = context;
        var params = new URLSearchParams();
        context.commit(ACTIONS.COMMODITY_SAVE_PENDING);
        params.append("Id", data.CommodityId == null ? 0 : data.CommodityId);
        params.append("Name", data.Name);
        params.append("Code", data.Code);
        params.append("Unit", data.Unit);
        params.append("Deleted", data.Deleted == false ? 0 : 1);
        params.append(
          "ISINTERNATIONAL",
          data.isInternational == false ? false : true,
        );
        commit(ACTIONS.COMMODITY_SAVE_PENDING);
        Api.post("commodities/add", params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.COMMODITY_SAVE_SUCCESS, data.ResponseData);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.COMMODITY_SAVE_ERROR, data.StatusMessage);
            } else if (data && data.StatusCode == 450) {
              commit(ACTIONS.COMMODITY_SAVE_ERROR, "Data is not valid format.");
              return resolve(res);
            } else {
              commit(ACTIONS.COMMODITY_SAVE_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              var { data } = err.response;
              if (err.response.status == 500) {
                context.commit(
                  ACTIONS.COMMODITY_SAVE_ERROR,
                  "Internal server error",
                );
              } else {
                context.commit(
                  ACTIONS.COMMODITY_SAVE_ERROR,
                  "Error " + err.status,
                );
              }
            } else if (err.request) {
              context.commit(
                ACTIONS.COMMODITY_SAVE_ERROR,
                "Error " + err.request,
              );
            } else {
              // Something happened in setting up the request that triggered an Error

              context.commit(
                ACTIONS.COMMODITY_SAVE_ERROR,
                "Error " + err.message,
              );
            }
            return reject(err);
          });
      });
    },
    [ACTIONS.COMMODITY_GET]: (context, CommodityId) => {
      return new Promise((resolve, reject) => {
        var { commit } = context;
        commit(ACTIONS.COMMODITY_GET_PENDING);
        Api.get("Commodities/GetCommodity" + "?id=" + CommodityId, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.COMMODITY_GET_SUCCESS);
              return resolve(res);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.COMMODITY_GET_ERROR, data.StatusMessage);
            } else {
              commit(ACTIONS.COMMODITY_GET_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              var { data } = err.response;
              if (err.response.status == 500) {
                context.commit(
                  ACTIONS.COMMODITY_GET_ERROR,
                  "Internal server error",
                );
              } else {
                context.commit(
                  ACTIONS.COMMODITY_GET_ERROR,
                  "Error " + err.status,
                );
              }
            } else if (err.request) {
              context.commit(
                ACTIONS.COMMODITY_GET_ERROR,
                "Error " + err.request,
              );
            } else {
              // Something happened in setting up the request that triggered an Error

              context.commit(
                ACTIONS.COMMODITY_GET_ERROR,
                "Error " + err.message,
              );
            }
            return reject(err);
          });
      });
    },
  },

  mutations: {
    [ACTIONS.COMMODITY_GETALL_SUCCESS]: (state, data) => {
      state.loading = false;
      state.errorMessage = null;
      state.totalPages = data.totalRecords;
      state.COMMODITIES = data.commodities;
    },
    [ACTIONS.COMMODITY_GETALL_PENDING]: (state) => {
      (state.loading = true), (state.errorMessage = null);
      state.COMMODITIES = [];
    },
    [ACTIONS.COMMODITY_GETALL_ERROR]: (state, msg) => {
      state.loading = false;
      state.errorMessage = msg;
      state.COMMODITIES = [];
    },
    [ACTIONS.VENDOR_COMMODITY_SAVE_PENDING]: (state) => {
      state.loading = true;
      state.errorMessage = null;
    },
    [ACTIONS.VENDOR_COMMODITY_SAVE_SUCCESS]: (state) => {
      state.loading = false;
      state.errorMessage = null;
    },
    [ACTIONS.VENDOR_COMMODITY_SAVE_ERROR]: (state, msg) => {
      state.loading = false;
      state.errorMessage = msg;
    },

    [ACTIONS.COMMODITY_SAVE_ERROR]: (state, msg) => {
      state.saveLoading = false;
      state.saveError = msg;
    },
    [ACTIONS.COMMODITY_SAVE_SUCCESS]: (state) => {
      state.saveLoading = false;
      state.saveError = null;
    },
    [ACTIONS.COMMODITY_SAVE_PENDING]: (state) => {
      state.saveLoading = true;
      state.saveError = null;
    },
    [ACTIONS.COMMODITY_GET_ERROR]: (state, msg) => {
      state.saveLoading = false;
      state.saveError = msg;
    },
    [ACTIONS.COMMODITY_GET_SUCCESS]: (state, data) => {
      state.saveLoading = false;
      state.saveError = null;
    },
    [ACTIONS.COMMODITY_GET_PENDING]: (state) => {
      state.saveLoading = true;
      state.saveError = null;
    },
  },
};

export default CommodityModule;
